// // src/pages/DemoAccessPage.jsx
// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   CircularProgress,
//   Typography,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   Box,
//   Chip,
// } from "@mui/material";

// const LOCAL_STORAGE_KEY = "demo_access_rows_v1";

// /**
//  * DemoAccessPage
//  *
//  * - No backend. Generates demo access links locally.
//  * - Columns: Town ID, Expiry Date, Demo Access Link
//  * - "Add" button opens modal with Town ID + Expiry Date + Generate button
//  * - No Actions column, no CSV export buttons
//  */
// const DemoAccessPage = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");

//   // Add dialog state
//   const [openAdd, setOpenAdd] = useState(false);
//   const [addForm, setAddForm] = useState({ townId: "", expiryDate: "" });
//   const [generating, setGenerating] = useState(false);

//   // Load from localStorage
//   useEffect(() => {
//     try {
//       const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
//       if (stored) setRows(JSON.parse(stored));
//     } catch (e) {
//       console.error("Failed to load rows from localStorage", e);
//     }
//   }, []);

//   // Persist to localStorage
//   useEffect(() => {
//     try {
//       localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(rows));
//     } catch (e) {
//       console.error("Failed to save rows to localStorage", e);
//     }
//   }, [rows]);

//   // helper: generate a pseudo-random token
//   const generateToken = (townId) => {
//     const rnd = Math.random().toString(36).slice(2, 9);
//     const time = Date.now().toString(36);
//     return `${townId || "t"}-${time}-${rnd}`;
//   };

//   // helper: create demo link string (you can change base URL later)
//   const createDemoLink = (townId, token) => {
//     return `https://demo.example.com/access/${encodeURIComponent(townId)}?token=${encodeURIComponent(
//       token
//     )}`;
//   };

//   const handleOpenAdd = () => {
//     setAddForm({ townId: "", expiryDate: "" });
//     setOpenAdd(true);
//   };
//   const handleCloseAdd = () => {
//     setOpenAdd(false);
//     setGenerating(false);
//   };

//   const handleAddChange = (e) => {
//     const { name, value } = e.target;
//     setAddForm((p) => ({ ...p, [name]: value }));
//   };

//   const handleGenerateAndAdd = () => {
//     // basic validation
//     if (!addForm.townId?.trim()) {
//       alert("Please enter Town ID.");
//       return;
//     }
//     if (!addForm.expiryDate) {
//       alert("Please select an expiry date.");
//       return;
//     }

//     setGenerating(true);

//     // simulate small delay for UX (but no backend call)
//     setTimeout(() => {
//       const token = generateToken(addForm.townId.trim());
//       const link = createDemoLink(addForm.townId.trim(), token);

//       const newRow = {
//         id: `${addForm.townId.trim()}_${Date.now()}`, // unique local id
//         town_id: addForm.townId.trim(),
//         expiry_date: addForm.expiryDate,
//         demo_link: link,
//         generated_at: new Date().toISOString(),
//       };

//       setRows((prev) => [newRow, ...prev]);
//       setGenerating(false);
//       setOpenAdd(false);
//     }, 400);
//   };

//   const filteredRows = rows.filter((r) =>
//     `${r.town_id} ${r.demo_link}`.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   return (
//     <Box sx={{ p: 2 }}>
//       <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//         <Typography style={{ fontWeight: "bold" }} variant="h4">
//           Demo Access Links
//         </Typography>

//         <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
//           <TextField
//             size="small"
//             placeholder="Search by town id or link..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <Button variant="contained" color="primary" onClick={handleOpenAdd}>
//             Add
//           </Button>
//         </Box>
//       </Box>

//       <TableContainer component={Paper}>
//         {loading ? (
//           <div style={{ textAlign: "center", padding: "20px" }}>
//             <CircularProgress />
//           </div>
//         ) : (
//           <>
//             <Table>
//               <TableHead sx={{ backgroundColor: "#152F8F" }}>
//                 <TableRow>
//                   <TableCell sx={{ color: "white" }}>
//                     <strong>Town ID</strong>
//                   </TableCell>
//                   <TableCell sx={{ color: "white" }}>
//                     <strong>Expiry Date</strong>
//                   </TableCell>
//                   <TableCell sx={{ color: "white" }}>
//                     <strong>Demo Access Link</strong>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {filteredRows.length === 0 ? (
//                   <TableRow>
//                     <TableCell colSpan={3} align="center" sx={{ p: 6 }}>
//                       <Typography>No demo links yet. Click Add to create one.</Typography>
//                     </TableCell>
//                   </TableRow>
//                 ) : (
//                   filteredRows.map((row) => {
//                     const expired =
//                       row.expiry_date && new Date(row.expiry_date) < new Date(new Date().toDateString());

//                     return (
//                       <TableRow key={row.id}>
//                         <TableCell>{row.town_id}</TableCell>

//                         <TableCell>
//                           {row.expiry_date}
//                           {expired && (
//                             <Chip label="Expired" color="error" size="small" sx={{ ml: 1 }} />
//                           )}
//                         </TableCell>

//                         <TableCell sx={{ maxWidth: 650 }}>
//                           <Typography
//                             variant="body2"
//                             sx={{
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                               maxWidth: "620px",
//                             }}
//                             title={row.demo_link}
//                           >
//                             {row.demo_link}
//                           </Typography>
//                         </TableCell>
//                       </TableRow>
//                     );
//                   })
//                 )}
//               </TableBody>
//             </Table>
//           </>
//         )}

//         {/* Add Modal */}
//         <Dialog open={openAdd} onClose={handleCloseAdd} fullWidth maxWidth="sm">
//           <DialogTitle>Create Demo Access Link</DialogTitle>
//           <DialogContent>
//             <TextField
//               margin="dense"
//               name="townId"
//               label="Town ID"
//               placeholder="e.g. TOWN-123"
//               value={addForm.townId}
//               onChange={handleAddChange}
//               fullWidth
//               autoFocus
//             />
//             <TextField
//               margin="dense"
//               name="expiryDate"
//               label="Expiry Date"
//               type="date"
//               value={addForm.expiryDate}
//               onChange={handleAddChange}
//               InputLabelProps={{ shrink: true }}
//               fullWidth
//             />
//             <Typography variant="caption" sx={{ display: "block", mt: 1 }}>
//               The generated link will be valid until the expiry date (demo only — no real validation yet).
//             </Typography>
//           </DialogContent>

//           <DialogActions>
//             <Button onClick={handleCloseAdd}>Cancel</Button>
//             <Button
//               variant="contained"
//               onClick={handleGenerateAndAdd}
//               disabled={generating}
//             >
//               {generating ? "Generating..." : "Generate"}
//             </Button>
//           </DialogActions>
//         </Dialog>
//       </TableContainer>
//     </Box>
//   );
// };

// export default DemoAccessPage;
// src/pages/DemoAccessPage.jsx
import React, { useEffect, useState } from "react";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
  CircularProgress, Typography, Button, Dialog, DialogTitle, DialogContent,
  DialogActions, TextField, Box, Chip, Autocomplete, IconButton, Tooltip,
  FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import BlockIcon from "@mui/icons-material/Block";
import { BACKEND_BASE_URL } from "../config";
import api from "../components/api";

const DemoAccessPage = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Add dialog state
  const [openAdd, setOpenAdd] = useState(false);
  const [selectedMunicipality, setSelectedMunicipality] = useState(null); // {id, name}
  const [expiryDays, setExpiryDays] = useState("7");
  const [credits, setCredits] = useState("0");
  const [userEmail, setUserEmail] = useState("");
  const [generating, setGenerating] = useState(false);

  // Delete confirmation dialog state
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [linkToDelete, setLinkToDelete] = useState(null);


  // Municipalities list for Autocomplete
  const [municipalities, setMunicipalities] = useState([]);
  const [municipalitiesLoading, setMunicipalitiesLoading] = useState(false);
  const [municipalitiesError, setMunicipalitiesError] = useState("");

  // Fetch municipalities on mount and when dialog opens
  useEffect(() => {
    const fetchMunicipalities = async () => {
      setMunicipalitiesLoading(true);
      setMunicipalitiesError("");
      try {
        const res = await api.get(`${BACKEND_BASE_URL}/api/demo/municipalities/`);
        console.log("MUNICIPALITIES response:", res?.data);
        const payload = res?.data;
        // Handle various response shapes: [{id, name}], {results: []}, etc.
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.results)
          ? payload.results
          : Array.isArray(payload?.municipalities)
          ? payload.municipalities
          : [];
        // Log sample to verify state field is present
        if (list.length > 0) {
          console.log("Sample municipality:", list[0]);
        }
        setMunicipalities(list);
      } catch (err) {
        console.error("Failed to fetch municipalities:", err);
        setMunicipalitiesError(err?.response?.data?.detail || "Failed to fetch municipalities");
        setMunicipalities([]);
      } finally {
        setMunicipalitiesLoading(false);
      }
    };
    fetchMunicipalities();
  }, []);

  // Fetch existing demo links on mount
  useEffect(() => {
    const fetchDemoLinks = async () => {
      setLoading(true);
      try {
        const res = await api.get(`${BACKEND_BASE_URL}/api/demo/demo-links/`);
        console.log("DEMO LINKS response:", res?.data);
        const payload = res?.data;
        const list = Array.isArray(payload)
          ? payload
          : Array.isArray(payload?.results)
          ? payload.results
          : [];
        // Map API response fields to match our table structure
        const mappedList = list.map((item) => {
          const townName = item.town_name || "N/A";
          const state = item.state || "";
          const county = item.county || "";
          
          // Build display text: "City, State" format
          let displayName = townName;
          if (state) {
            // Check if state looks like a city name (contains the city name)
            const stateLower = state.toLowerCase();
            const nameLower = townName.toLowerCase();
            if (stateLower.includes(nameLower) || nameLower.includes(stateLower)) {
              // State appears to be a city name, use county if available
              displayName = county ? `${townName}, ${county}` : townName;
            } else {
              // Normal state, display as "City, State"
              displayName = `${townName}, ${state}`;
            }
          } else if (county) {
            // No state but has county
            displayName = `${townName}, ${county}`;
          }
          
          return {
            id: item.id,
            town_id: displayName, // Display format: "City, State"
            town_name: item.town_name,
            state: item.state,
            county: item.county,
            expiry_date: item.expires_at, // Map expires_at to expiry_date
            expires_at: item.expires_at,
            demo_link: item.demo_link,
            token: item.token,
            created_at: item.created_at,
            is_active: item.is_active !== false
          };
        });
        setRows(mappedList);
      } catch (err) {
        console.error("Failed to fetch demo links:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchDemoLinks();
  }, []);

  // open/close handlers
  const handleOpenAdd = () => {
    setSelectedMunicipality(null);
    setExpiryDays("7");
    setCredits("0");
    setUserEmail("");
    setOpenAdd(true);
  };
  const handleCloseAdd = () => {
    setOpenAdd(false);
    setGenerating(false);
    setSelectedMunicipality(null);
    setExpiryDays("7");
    setCredits("0");
    setUserEmail("");
  };

  const handleGenerateAndAdd = async () => {
    if (!selectedMunicipality) {
      alert("Please select a town.");
      return;
    }
    const expiryDaysNum = parseInt(expiryDays);
    if (!expiryDays || isNaN(expiryDaysNum) || expiryDaysNum < 1) {
      alert("Please enter a valid expiry days (minimum 1 day).");
      return;
    }

    setGenerating(true);
    try {
      const requestData = {
        municipality: selectedMunicipality.id,
        expiry_days: expiryDaysNum,
        credits: parseInt(credits) || 0
      };
      
      // Add user_email if provided
      if (userEmail && userEmail.trim()) {
        requestData.user_email = userEmail.trim();
      }
      
      const res = await api.post(`${BACKEND_BASE_URL}/api/demo/demo-links/`, requestData);
      
      console.log("Demo link created:", res.data);
      
      // Build display name with state
      const townName = res.data.town_name || selectedMunicipality.name;
      const state = res.data.state || selectedMunicipality.state || "";
      const county = res.data.county || selectedMunicipality.county || "";
      
      let displayName = townName;
      if (state) {
        const stateLower = state.toLowerCase();
        const nameLower = townName.toLowerCase();
        if (stateLower.includes(nameLower) || nameLower.includes(stateLower)) {
          displayName = county ? `${townName}, ${county}` : townName;
        } else {
          displayName = `${townName}, ${state}`;
        }
      } else if (county) {
        displayName = `${townName}, ${county}`;
      }
      
      // Add to rows (prepend to show newest first)
      const newRow = {
        id: res.data.id,
        town_id: displayName, // Display format: "City, State"
        town_name: townName,
        state: state,
        county: county,
        expiry_date: res.data.expires_at,
        demo_link: res.data.demo_link,
        token: res.data.token,
        created_at: res.data.created_at,
        is_active: res.data.is_active !== false
      };
      setRows((prev) => [newRow, ...prev]);
      
      setOpenAdd(false);
      alert(`Demo link created successfully!\n\nLink: ${res.data.demo_link}`);
    } catch (err) {
      console.error("Failed to create demo link:", err);
      const errorMsg = err?.response?.data?.error || err?.response?.data?.detail || "Failed to create demo link";
      alert(`Error: ${errorMsg}`);
    } finally {
      setGenerating(false);
    }
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
    alert("Link copied to clipboard!");
  };

  const handleRevoke = async (id) => {
    if (!window.confirm("Are you sure you want to revoke this demo link?")) {
      return;
    }
    try {
      await api.patch(`${BACKEND_BASE_URL}/api/demo/demo-links/${id}/revoke/`);
      setRows((prev) => prev.map((row) => 
        row.id === id ? { ...row, is_active: false } : row
      ));
      alert("Demo link revoked successfully!");
    } catch (err) {
      console.error("Failed to revoke demo link:", err);
      alert("Failed to revoke demo link");
    }
  };

  const handleDeleteClick = (id) => {
    const row = rows.find((r) => r.id === id);
    setLinkToDelete({ id, town_name: row?.town_id || row?.town_name || "Unknown" });
    setOpenDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!linkToDelete) return;
    
    try {
      await api.delete(`${BACKEND_BASE_URL}/api/demo/demo-links/${linkToDelete.id}/`);
      setRows((prev) => prev.filter((row) => row.id !== linkToDelete.id));
      setOpenDeleteConfirm(false);
      setLinkToDelete(null);
      alert("Demo link deleted successfully!");
    } catch (err) {
      console.error("Failed to delete demo link:", err);
      alert("Failed to delete demo link");
    }
  };

  const handleDeleteCancel = () => {
    setOpenDeleteConfirm(false);
    setLinkToDelete(null);
  };


  const filteredRows = rows.filter((r) =>
    `${r.town_id || ""} ${r.demo_link || ""}`.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Box sx={{ p: 2 }}>
      <Box sx={{ p: 2, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography style={{ fontWeight: "bold" }} variant="h4">Demo Access Links</Typography>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <TextField size="small" placeholder="Search by town id or link..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} />
          <Button variant="contained" color="primary" onClick={handleOpenAdd}>Add Demo Link</Button>
        </Box>
      </Box>

      <TableContainer component={Paper}>
        {loading ? (<div style={{ textAlign: "center", padding: "20px" }}><CircularProgress /></div>) : (
          <>
            <Table>
              <TableHead sx={{ backgroundColor: "#152F8F" }}>
                <TableRow>
                  <TableCell sx={{ color: "white" }}><strong>Town Name</strong></TableCell>
                  <TableCell sx={{ color: "white" }}><strong>Expires At</strong></TableCell>
                  <TableCell sx={{ color: "white" }}><strong>Demo Access Link</strong></TableCell>
                  <TableCell sx={{ color: "white" }}><strong>Actions</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ p: 6 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredRows.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center" sx={{ p: 6 }}>
                      <Typography>No demo links yet. Click Add to create one.</Typography>
                    </TableCell>
                  </TableRow>
                ) : filteredRows.map((row) => {
                  // Check both expiry_date and expires_at for compatibility
                  const expiryValue = row.expiry_date || row.expires_at;
                  const expired = expiryValue && new Date(expiryValue) < new Date();
                  const expiryDate = expiryValue ? new Date(expiryValue).toLocaleString() : "N/A";
                  const isActive = row.is_active !== false;
                  return (
                    <TableRow key={row.id}>
                      <TableCell>{row.town_id || row.town_name || "N/A"}</TableCell>
                      <TableCell>
                        {expiryDate}
                        {expired && <Chip label="Expired" color="error" size="small" sx={{ ml: 1 }} />}
                        {!isActive && <Chip label="Revoked" color="warning" size="small" sx={{ ml: 1 }} />}
                      </TableCell>
                      <TableCell sx={{ maxWidth: 500 }}>
                        <Typography
                          variant="body2"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "450px",
                            color: "primary.main"
                          }}
                          title={row.demo_link}
                        >
                          {row.demo_link}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Box sx={{ display: "flex", gap: 1 }}>
                          <Tooltip title="Copy Link">
                            <IconButton
                              size="small"
                              onClick={() => handleCopyLink(row.demo_link)}
                              color="primary"
                            >
                              <ContentCopyIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {isActive && (
                            <Tooltip title="Revoke Link">
                              <IconButton
                                size="small"
                                onClick={() => handleRevoke(row.id)}
                                color="warning"
                              >
                                <BlockIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip title="Delete Link">
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteClick(row.id)}
                              color="error"
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </>
        )}

        {/* Add Modal */}
        <Dialog open={openAdd} onClose={handleCloseAdd} fullWidth maxWidth="sm">
          <DialogTitle>Create Demo Access Link</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
              {/* Searchable Town Autocomplete */}
              <Autocomplete
                options={municipalities}
                getOptionLabel={(option) => {
                  if (!option) return "";
                  const name = option.name || option.municipality_name || "";
                  const state = option.state || "";
                  const county = option.county || "";
                  
                  // Build display text: prefer "City, State" format
                  // If state looks like a city name (contains the city name), use county instead
                  if (state) {
                    // Check if state is actually a city name (state contains city name)
                    const stateLower = state.toLowerCase();
                    const nameLower = name.toLowerCase();
                    if (stateLower.includes(nameLower) || nameLower.includes(stateLower)) {
                      // State appears to be a city name, use county if available
                      return county ? `${name}, ${county}` : name;
                    } else {
                      // Normal state, display as "City, State"
                      return `${name}, ${state}`;
                    }
                  } else if (county) {
                    // No state but has county
                    return `${name}, ${county}`;
                  }
                  return name;
                }}
                value={selectedMunicipality}
                onChange={(event, newValue) => {
                  setSelectedMunicipality(newValue);
                }}
                loading={municipalitiesLoading}
                filterOptions={(options, params) => {
                  const filtered = options.filter((option) => {
                    const name = (option.name || option.municipality_name || "").toLowerCase();
                    const state = (option.state || "").toLowerCase();
                    const county = (option.county || "").toLowerCase();
                    const inputValue = params.inputValue.toLowerCase();
                    return name.includes(inputValue) || state.includes(inputValue) || county.includes(inputValue);
                  });
                  return filtered;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Town"
                    placeholder="Search for a town (e.g., Springfield, IL)..."
                    margin="dense"
                    error={!!municipalitiesError}
                    helperText={municipalitiesError || "Type to search for a town (City, State)"}
                  />
                )}
                renderOption={(props, option) => {
                  const name = option.name || option.municipality_name || "";
                  const state = option.state || "";
                  const county = option.county || "";
                  
                  // Build display text: prefer "City, State" format
                  // If state looks like a city name (contains the city name), use county instead
                  let displayText = name;
                  if (state) {
                    // Check if state is actually a city name (state contains city name)
                    const stateLower = state.toLowerCase();
                    const nameLower = name.toLowerCase();
                    if (stateLower.includes(nameLower) || nameLower.includes(stateLower)) {
                      // State appears to be a city name, use county if available
                      displayText = county ? `${name}, ${county}` : name;
                    } else {
                      // Normal state, display as "City, State"
                      displayText = `${name}, ${state}`;
                    }
                  } else if (county) {
                    // No state but has county
                    displayText = `${name}, ${county}`;
                  }
                  
                  return (
                    <Box component="li" {...props} key={option.id}>
                      <Typography>{displayText}</Typography>
                    </Box>
                  );
                }}
                isOptionEqualToValue={(option, value) => option?.id === value?.id}
                noOptionsText={municipalitiesLoading ? "Loading..." : "No towns found"}
              />

              {/* Expiry Days */}
              <TextField
                label="Expiry Days"
                type="number"
                value={expiryDays}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow empty string or any input (let user type freely)
                  setExpiryDays(value);
                }}
                onBlur={(e) => {
                  // Set default if empty on blur
                  const value = e.target.value;
                  if (value === "" || isNaN(parseInt(value)) || parseInt(value) < 1) {
                    setExpiryDays("7");
                  }
                }}
                InputProps={{ inputProps: { min: 1, max: 365 } }}
                margin="dense"
                fullWidth
                helperText="Number of days until the demo link expires (1-365 days)"
              />
              
              {/* Credits */}
              <TextField
                label="Explain Credits"
                type="number"
                value={credits}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow empty string or any input (let user type freely)
                  setCredits(value);
                }}
                onBlur={(e) => {
                  // Set default if empty on blur
                  const value = e.target.value;
                  if (value === "" || isNaN(parseInt(value)) || parseInt(value) < 0) {
                    setCredits("0");
                  }
                }}
                InputProps={{ inputProps: { min: 0 } }}
                margin="dense"
                fullWidth
                helperText="Number of explain credits to assign to demo users (0 = no credits)"
              />

              {/* User Email (Optional) */}
              <TextField
                label="User Email (Optional)"
                type="email"
                value={userEmail}
                onChange={(e) => setUserEmail(e.target.value)}
                margin="dense"
                fullWidth
                helperText="If provided, a user account will be created/updated and credentials will be sent via email"
                placeholder="user@example.com"
              />

              <Typography variant="caption" sx={{ display: "block", mt: 1, color: "text.secondary" }}>
                The generated link will allow users to view all summaries for the selected town without authentication.
                The link will expire after the specified number of days.
                {userEmail && userEmail.trim() && " A user account will be created and credentials will be emailed."}
              </Typography>
            </Box>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseAdd} disabled={generating}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleGenerateAndAdd}
              disabled={generating || !selectedMunicipality || !expiryDays || isNaN(parseInt(expiryDays)) || parseInt(expiryDays) < 1}
            >
              {generating ? "Generating..." : "Generate Link"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Delete Confirmation Dialog */}
        <Dialog open={openDeleteConfirm} onClose={handleDeleteCancel}>
          <DialogTitle>Delete Demo Link</DialogTitle>
          <DialogContent>
            <Typography>
              Are you sure you want to delete the demo link for <strong>{linkToDelete?.town_name}</strong>?
            </Typography>
            <Typography variant="body2" sx={{ mt: 1, color: "error.main" }}>
              This action cannot be undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel}>Cancel</Button>
            <Button onClick={handleDeleteConfirm} color="error" variant="contained">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

      </TableContainer>
    </Box>
  );
};

export default DemoAccessPage;
